<template>
    <div>
        <div v-if="editing" class="input-group mb-3">
            <div class="input-group-prepend">
                <button class="btn btn-success btn-sm" v-on:click="save">
                    <font-awesome-icon icon="check" />
                </button>
                <button class="btn btn-dark btn-sm" v-on:click="cancel">
                    <font-awesome-icon icon="times" />
                </button>
            </div>
            <input
                    v-model="internalValue"
                    type="text"
                    class="form-control"
                    :placeholder="placeholder"
                    ref="inputField"
                    v-on:keyup.enter="save"
            />
        </div>
        <div v-else>
            <button class="btn btn-success btn-sm" v-on:click="edit">
                <font-awesome-icon icon="edit" />
            </button>
            <span class="ml-2">{{ displayValue }}</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'editable-text-field',
        props: {
            value: {
                type: String,
            },
            defaultValue: {
                type: String,
                default: 'Content',
            },
            placeholder: {
                type: String,
                default: 'Content'
            }
        },
        data() {
            return {
                editing: false,
                internalValue: this.value,
            }
        },
        watch: {
            value(value) {
                this.internalValue = value;
            }
        },
        computed: {
            displayValue() {
                if (this.internalValue) {
                    return this.internalValue;
                }

                return this.defaultValue;
            }
        },
        methods: {
            cancel() {
                this.editing = false;
            },
            edit() {
                this.editing = true;

                this.$nextTick(() => {
                    let inputField = this.$refs['inputField'];

                    inputField.focus();
                    inputField.select();
                });
            },
            save() {
                this.editing = false;

                this.$emit('input', this.internalValue);
            }
        }
    }
</script>